import classNames from 'classnames';
import { type CSSProperties } from 'react';

interface BorderExampleProps {
    className: string;
    width: CSSProperties['width'];
}

export const BorderExample = ({ className, width }: BorderExampleProps) => (
    <div className={classNames('sds_border-example__radius', className)} style={{ width }} />
);
